import React from 'react'

// eslint-disable-next-line import/no-anonymous-default-export
export default () => (
  <h1>
    Admin Setting
  </h1>
)